<template>
  <div class="pushes">
    <Push v-for="(item, index) in visiblePushes" :key="item.id" :push="item" @close="deleteItem(index)"></Push>
  </div>
</template>
<script>
import Push from './Push'
import shuffle from '../utils/shuffle'

const missPush = {
  id: 'miss',
  name: 'miss',
  from: 'Без вашей подписи никуда!',
  text: 'Будьте внимательны',
}

const getPushes = () => {
  const pushes = [
    {
      name: 'mom',
      from: 'Мама',
      text: 'Не забудь покушать. И не ходи без шапки. Почему ты о себе никогда не заботишься?',
    },
    {
      name: 'coin',
      from: '0808',
      text: 'Вам одобрен кредит на 2 000 000 рублей под 27% годовых.',
    },
    {
      name: 'helicopter',
      from: 'МЧС',
      text: 'Завтра +20 +23, переменная облачность, без осадков, давление 120 сантиметров ртутного столба.',
    },
    {
      name: 'ved',
      from: 'Ведомости',
      text: 'Госдума приняла закон о суверенном Рунете.',
    },
    {
      name: 'viking',
      from: 'Viking Clash of Warlord’s Clans',
      text: 'Ваши жизни восстановлены, вы опять можете играть.',
    },

    {
      name: 'ved',
      from: 'Ведомости',
      text: 'Власти ограничат исполнителей национальных проектов в выборе поставщиков.',
    },
    {
      name: 'pills',
      from: 'Твое здоровье',
      text: 'Срочно попей воды.',
    },
    {
      name: 'present',
      from: '+7 (925) 783 …',
      text: 'СО СВЕТЛЫМ ПРАЗДНИКОМ МЫ ПОЗДРАВЛЯЕМ, СЧАСТЬЯ, РАДОСТИ ЖЕЛАЕМ, ПУСТЬ ЖЕ СЧАСТЬЕ БУДЕТ В ДОМЕ!!!!!',
    },

    {
      name: 'girl',
      from: '+7 (926) 559 …',
      text: 'Уже месяц прошел, а ты не перезваниваешь',
    },
    {
      name: 'death',
      from: '+7 (926) 789 …',
      text: 'ПЕРЕШЛИ ЭТО СООБЩЕНИЕ 20 КОНТАКТАМ, И СЧАСТЬЕ БУДЕТ И ТЕБЕ, И ИМ. А ЕСЛИ НЕ ПЕРЕШЛЕШЬ, ТО ВСЁ',
    },
    {
      name: 'eng',
      from: 'Английский каждый день',
      text: 'Слово дня сегодня – ambidextrous (двуличный, владеющий двумя руками)',
    },
    {
      name: 'inst',
      from: 'Новые маски для селфи',
      text: 'Сделайте селфи в космосе с летающими огурцами и котиком',
    },
    {
      name: 'mom',
      from: 'Мама',
      text: 'Нашла 100 легких рецептов. Почитай, прикольно!',
    },
    {
      name: 'palm',
      from: 'ОТДЫХ В ТУРЦИИ!',
      text: 'Соберитесь в отпуск сейчас, жалейте потом',
    },
    // {
    //   name: 'tv',
    //   from: 'Новое видео на YouTube',
    //   text: 'Леонид Якубович в игре Mortal Kombat',
    // },
    {
      name: 'wash',
      from: 'Бытовая техника',
      text:
        'Поздравляем, вы покупатель 1.000.000! Заберите ваш великолепный подарок — фарфоровую подставку для зубочисток!',
    },
    {
      name: 'taxi',
      from: 'Такси',
      text: 'Оцените качество поездки. Получите возможность проехать на машине класса Премиум!',
    },
  ]

  return shuffle(
    pushes.map((item, index) => {
      return {
        ...item,
        id: item.name + index,
      }
    })
  )
}

const pushes = getPushes()
let timeout = null

export default {
  name: 'Pushes',
  components: { Push },
  props: {
    level: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      pushes: pushes,
      visiblePushes: [],
    }
  },
  methods: {
    start() {
      timeout = setTimeout(() => {
        this.showPush()
        // }, 1500 + Math.random() * 3500)
      }, 6500 + Math.random() * 3500)
    },
    showPush() {
      this.visiblePushes.push(this.pushes[0])
      const shifted = this.pushes.shift()
      const newPush = { ...shifted, id: shifted.id + '1' }
      this.pushes.push(newPush)

      this.start()
    },
    deleteItem(index) {
      this.visiblePushes.splice(index, 1)
    },
    onMiss() {
      missPush.id += '1'
      this.visiblePushes.push({ ...missPush })
    },
  },
  mounted() {
    this.start()
    this.$root.$on('docMiss', this.onMiss)
  },
  beforeDestroy() {
    clearTimeout(timeout)
  },
}
</script>

<style lang="scss">
.pushes {
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  z-index: 3;
  max-height: 90%;
  overflow-y: hidden;
}
</style>
